module.exports = __webpack_public_path__ + "images/MultiChoice_loop.gif";